export enum EntityTypeEnum {
    EMPLOYEE = 'employee',
    PARENT = 'parent',
    STUDENT = 'student',
    SCHOOL = 'school',
    ADMINISTRATOR = 'administrator',
    CLASS = 'class',
    GROUP = 'group',
    GROUP_PERSO = 'group_perso',
    GROUP_PREDEFINED = 'group_predefined',
    CONTACT = 'contact',
    RELATIVE = 'relative',
}
